import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const AdditionToNewProjectCover = ({ notification, sender, project }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `قام ${sender?.name} بضمك الى مشروعه`
    : `${sender?.name} added you to ${project?.name} project`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default AdditionToNewProjectCover
